// src/components/Chat/EnterPasswordDialog.jsx
import { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, CircularProgress, Alert,
} from '@mui/material';
import api from '../../api/axios';

/** 비공개 채팅방 비밀번호 입력 모달 */
const EnterPasswordDialog = ({ open, categoryId, onCancel, onSuccess }) => {
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!password.trim()) { setErrorMsg('비밀번호를 입력하세요.'); return; }

        setLoading(true); setErrorMsg('');
        try {
            const res = await api.post(`/api/chat/categories/${categoryId}/enter/`, { password });
            onSuccess(res.data.nickname || '익명', password);          // ⬅️ 닉네임 + 비번 반환
            setPassword('');
        } catch (err) {
            const msg = err.response?.data?.error || '인증에 실패했습니다.';
            setErrorMsg(msg);
        } finally { setLoading(false); }
    };

    const handleCancel = () => { if (!loading) { setPassword(''); setErrorMsg(''); onCancel(); } };

    return (
        <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
            <DialogTitle>비공개 채팅방 입장</DialogTitle>
            <DialogContent dividers>
                <form id="pwd-form" onSubmit={handleSubmit}>
                    <TextField
                        label="비밀번호" type="password" fullWidth autoFocus
                        value={password} onChange={(e) => setPassword(e.target.value)} disabled={loading}
                    />
                    {errorMsg && <Alert severity="error" sx={{ mt: 2 }}>{errorMsg}</Alert>}
                </form>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleCancel} disabled={loading}>취소</Button>
                <Button type="submit" form="pwd-form" variant="contained" disabled={loading}>
                    {loading ? <CircularProgress size={24} /> : '입장하기'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default EnterPasswordDialog;

